import '@babel/polyfill'
import 'matchmedia-polyfill'
import 'matchmedia-polyfill/matchMedia.addListener'

import Vue from 'vue'
import App from './App.vue'

import VueCookies from 'vue-cookies'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import KSVLivetickerShared from '@custom-media/ksv-liveticker-shared'

import VueMq from 'vue-mq'

Sentry.init({
	release: process.env.VUE_APP_SENTRY_RELEASE,
	dsn: 'https://391cfdb686924583a612f79a98194ab9@sentry.io/1505863',
	environment: process.env.VUE_APP_ENVIRONMENT,
	integrations (integrations) {
		if (process.env.NODE_ENV === 'production') {
			integrations.push(new Integrations.Vue({ Vue, attachProps: true }))
		}
		return integrations
	}
})

Vue.config.productionTip = false
Vue.use(KSVLivetickerShared)
Vue.use(VueCookies)

// Configure breakpoints of vue-mq plugin
Vue.use(VueMq, {
	breakpoints: {
		mobile: 768 + 1,
		tablet: 1024 + 1,
		desktop: 1216 + 1,
		widescreen: 1408 + 1,
		fullhd: Infinity
	},
	defaultBreakpoint: 'mobile'
})

// Small padding function used in the formattedDateTime filter
function pad (num) {
	return num < 10 ? '0' + num.toString() : num.toString()
}
// Filter for formatting dates in 'DD.MM.YY HH:MM Uhr' format
Vue.filter('formattedDateTime', function (value) {
	if (!value) { return '' }
	const date = new Date(value)
	if (!(date instanceof Date) || isNaN(date)) { return '' }
	const day = date.getDate()
	const month = date.getMonth()
	const year = date.getFullYear().toString().substr(-2)
	const hour = date.getHours()
	const minute = date.getMinutes()
	return `${pad(day)}.${pad(month + 1)}.${year} ${pad(hour)}:${pad(minute)} Uhr`
})

new Vue({
	render: h => h(App)
}).$mount('#app')
